module.exports = __webpack_public_path__ + "img/posted-note.da3b2a56.png";